import { useTranslation } from 'react-i18next';

import { StyledButton } from '@selfserve/react-ui';
import { apiEndpoints, buttonIds } from '@selfserve/react-utils';
import { useAuth } from '@selfserve/react-hooks';

export const AddPlan = ({ isLink }: { isLink?: boolean }) => {
  const { t } = useTranslation();
  const { token } = useAuth();

  return (
    <form
      id={buttonIds.overviewAddPlan}
      action={apiEndpoints.addPlan}
      method="post"
      target="_blank"
    >
      <input type="hidden" name="token" value={token} />
      <input type="hidden" name="path" value="upgrade" />
      <StyledButton
        id={buttonIds.overviewAddPlan}
        type="submit"
        isLink={isLink}
        withoutMargin
      >
        <span className="p-button-label">
          {t(`common.${isLink ? 'add-a-plan' : 'add-plan'}`)}
        </span>
      </StyledButton>
    </form>
  );
};
